module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newtoken":"New token"},"fr":{"newtoken":"Nouveau token"}}')
  delete Component.options._Ctor
}
